import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './FlatBox.module.scss.js';

const { componentTestLabel } = getTestLabels('FlatBox');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Box/FlatBox.tsx)
 *
 * @param {boolean} rounded - (optional) Applies rounded corners if true.
 * @param {string} variant - (optional) One of `neutral`, ~~`grey`~~ (deprecated alias to `neutral`), or `white`.
 */
const FlatBox = forwardRef((props, ref) => {
    const { children, className, variant = 'neutral', rounded, ...otherProps } = props;
    const fixedVariant = variant === 'grey' ? 'neutral' : variant;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-flatbox'], {
            [style['z-flatbox--rounded']]: rounded,
            [style[`z-flatbox--${fixedVariant}`]]: fixedVariant !== 'neutral',
        }), ...otherProps, children: children }));
});
FlatBox.displayName = 'FlatBox';

export { FlatBox };
//# sourceMappingURL=FlatBox.js.map
